export enum ProductOrderByInput {
  product_id__ASC = "commodity_id__ASC",
  product_id__DESC = "commodity_id__DESC"
}
